import { useEffect, useState } from "react";
import { SiTidal, SiYoutube, SiSpotify, SiApplemusic, SiBandcamp } from "react-icons/si";
import { FaDeezer } from "react-icons/fa";
import { toast } from "sonner";
import { getFoundLinks } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export const SOURCE_ICONS = {
  Tidal: [SiTidal, "#000000"],
  YouTube: [SiYoutube, "#ff0000"],
  Spotify: [SiSpotify, "#1db954"],
  "Apple Music": [SiApplemusic, "#fa2d48"],
  Deezer: [FaDeezer, "#a238ff"],
  Bandcamp: [SiBandcamp, "#1da0c3"],
};

// the links through which this user found the tune — tap to copy
export const FoundLinks = ({ tuneId }) => {
  const { user } = useAuth();
  const [links, setLinks] = useState([]);

  useEffect(() => {
    setLinks([]);
    if (!user) return;
    getFoundLinks(tuneId)
      .then((d) => setLinks(d.links || []))
      .catch(() => {});
  }, [tuneId, user]);

  const copy = async (l) => {
    try {
      await navigator.clipboard.writeText(l.url);
      toast.success(`${l.source} link copied`);
    } catch {
      toast.error("Could not copy the link");
    }
  };

  return links.map((l) => {
    const [Icon, color] = SOURCE_ICONS[l.source] || [SiYoutube, "#2d2824"];
    return (
      <button
        key={l.source}
        onClick={() => copy(l)}
        title={`Found via ${l.source} — tap to copy the link`}
        className="flex h-9 w-9 items-center justify-center rounded-full border border-[#e5e0d8] bg-white transition-transform hover:scale-110"
        data-testid={`found-link-${l.source.toLowerCase().replace(" ", "-")}`}
      >
        <Icon className="h-4 w-4" style={{ color }} />
      </button>
    );
  });
};
